/**
 * EventHandlers - Event handling utilities for EdgeDocs Canvas
 *
 * Extracted from EdgeDocsCanvas.V3.tsx for better modularity and testability.
 *
 * This utility provides centralized event handling for mouse and keyboard events.
 */

export interface EventHandlerDependencies {
  inputHandler: any; // UseEdgeDocsInput handler
}

// 🔬 LISTENER TRACKING: Counter for listener IDs
let listenerIdCounter = 0;

/**
 * Setup keyboard event listeners
 */
export function setupKeyboardEventListeners(deps: EventHandlerDependencies): () => void {
  const { inputHandler } = deps;
  
  // 🔬 LISTENER_ADD diagnostic
  listenerIdCounter++;
  const listenerId = listenerIdCounter;
  console.log(`🔬 LISTENER_ADD keydown listenerId=${listenerId} node=window`);

  const handleKeyDown = (e: KeyboardEvent) => {
    // ✅ DISABLED: Logging on every keystroke was causing performance issues
    const handled = inputHandler.handleKeyDown(e);
    if (handled) {
      e.preventDefault();
    }
  };

  window.addEventListener('keydown', handleKeyDown);

  return () => {
    // 🔬 LISTENER_REMOVE diagnostic
    console.log(`🔬 LISTENER_REMOVE keydown listenerId=${listenerId}`);
    window.removeEventListener('keydown', handleKeyDown);
  };
}

/**
 * Create keyboard event handler setup for useEffect
 */
export function createKeyboardEventSetup(deps: EventHandlerDependencies) {
  return () => setupKeyboardEventListeners(deps);
}
